import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { fireLogEvent, Namespace, sendRioEvent, SpecType } from '@chegg/commerce-utils';
import { EMPTY_ADDRESS_VALUE } from '@chegg/payment-methods';
import { sendNewRelicMessage } from './NewRelicUtils';
export var RecurlyPaymentTypesToRioMap = new Map([['CREDIT_CARD', 'Credit Card'], ['APPLE_PAY', 'ApplePay'], ['BRAINTREE_APPLE_PAY', 'ApplePay'], ['PAYPAL', 'Paypal'], ['BRAINTREE_V_ZERO', 'Paypal'], ['VENMO', 'Venmo'], ['GOOGLE_PAY', 'Gpay']]);
export var LogRioPurchaseEvent = function LogRioPurchaseEvent(data, cart, rioNamespace) {
  var _methodOfPayment$mopI;
  var items = cart.items;
  var createPurchase = data.createPurchase;
  var currency = createPurchase.currency,
    _createPurchase$subsc = createPurchase.subscription,
    methodOfPayment = _createPurchase$subsc.methodOfPayment,
    sourceVendor = _createPurchase$subsc.sourceVendor,
    promotionRedemptions = _createPurchase$subsc.promotionRedemptions,
    invoices = _createPurchase$subsc.invoices,
    vendorPlan = _createPurchase$subsc.vendorPlan;
  var NRPurchaseData = {
    action: 'JOIN',
    paymentMethod: methodOfPayment.mopInfo.type,
    productType: vendorPlan.family,
    externalId: vendorPlan.code,
    cardType: ((_methodOfPayment$mopI = methodOfPayment.mopInfo.card) === null || _methodOfPayment$mopI === void 0 ? void 0 : _methodOfPayment$mopI.cardType) && methodOfPayment.mopInfo.card.cardType || ''
  };
  var promotionDetail = promotionRedemptions !== null && promotionRedemptions !== void 0 && promotionRedemptions.length ? {
    coupon_code: promotionRedemptions[0].code,
    coupon_discount_amount: promotionRedemptions[0].discountAmount
  } : {
    coupon_code: '',
    coupon_discount_amount: 0
  };
  var rioPurchaseData = {
    transaction_id: sourceVendor.vendorSubscriptionId,
    order: {
      currency_code: currency,
      subtotal: invoices[0].subTotal,
      tax_paid: invoices[0].tax,
      total: invoices[0].totalAmount
    },
    products: [{
      display_price: invoices[0].subTotal,
      product_id: vendorPlan.code,
      product_type: vendorPlan.family,
      quantity: items[0].quantity
    }],
    purchase: _objectSpread({
      billing_address: {
        city: methodOfPayment.billingAddress.city || EMPTY_ADDRESS_VALUE,
        country_code: methodOfPayment.billingAddress.country || EMPTY_ADDRESS_VALUE,
        postal_code: methodOfPayment.billingAddress.postalCode || EMPTY_ADDRESS_VALUE,
        state_province_region: methodOfPayment.billingAddress.state || EMPTY_ADDRESS_VALUE
      },
      payments: [RecurlyPaymentTypesToRioMap.get(methodOfPayment.mopInfo.type)]
    }, promotionDetail)
  };
  sendNewRelicMessage('Recurly Order placed successfully', _objectSpread({}, NRPurchaseData));
  sendRioEvent({
    info: JSON.stringify(rioPurchaseData),
    specType: SpecType.PURCHASE,
    callback: function callback(logObj) {
      return fireLogEvent(logObj, Namespace.DROP_IN_PAYMENTS);
    },
    namespace: rioNamespace
  });
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/dropin-payments/dist/esm/utils/RecurlyRioPurchaseEvent.js
// module id = 4678
// module chunks = 11